import { render, staticRenderFns } from "./BaseActionGroup.vue?vue&type=template&id=4713ca04"
import script from "./BaseActionGroup.vue?vue&type=script&lang=js"
export * from "./BaseActionGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseActionGroup.vue?vue&type=style&index=0&id=4713ca04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports